import { render, staticRenderFns } from "./ColumnNameSettings.vue?vue&type=template&id=52dbec7e"
import script from "./ColumnNameSettings.vue?vue&type=script&lang=ts"
export * from "./ColumnNameSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52dbec7e')) {
      api.createRecord('52dbec7e', component.options)
    } else {
      api.reload('52dbec7e', component.options)
    }
    module.hot.accept("./ColumnNameSettings.vue?vue&type=template&id=52dbec7e", function () {
      api.rerender('52dbec7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reminder-layout-editor/ColumnNameSettings.vue"
export default component.exports